( function( $ ) {

    var WebsiteLivesite = {

        OpenScheduler: function ( el ) {

            WebsiteLivesite.ParseProps( el );

            LiveSite.schedule( {
                service  : WebsiteLivesite.props[ 'service' ],
                title    : WebsiteLivesite.props[ 'title'   ],
                source   : WebsiteLivesite.props[ 's'       ],
                campaign : WebsiteLivesite.props[ 'vtm_cp'  ]
            } );

            WebsiteLivesite.FacebookLead();

        },

        OpenLeaveDetails: function ( el ) {

            WebsiteLivesite.ParseProps( el );

            LiveSite.contact( {
                action: WebsiteLivesite.props['action']
            } );

            WebsiteLivesite.FacebookLead();

        },

        ParseProps: function( el ) {

            WebsiteLivesite.props = {};
            var prop = '';

            el.attr( 'href' ).split( '?' )[1].split( '&' ).forEach( function( item ) {
                prop = item.split('=');
                WebsiteLivesite.props[ prop[0] ] = decodeURIComponent( prop[1] );
            } );

        },

        FacebookLead: function () {
            if (fbq) fbq( 'track', 'Lead' );
        }

    };

    $(document).ready( function() {

        $( 'a[href*="vcita.sales/online-scheduling?service="]' ).click( function( e ) {
            e.preventDefault();
            WebsiteLivesite.OpenScheduler( $(this) );
        } );

        $( 'a[href*="vcita.sales/leave-details?action="]' ).click( function( e ) {
            e.preventDefault();
            WebsiteLivesite.OpenLeaveDetails( $(this) );
        } );

        $( '.livesite-schedule' ).click( function() {
            WebsiteLivesite.FacebookLead();
        } );

    } );

})(jQuery);